
const info={
    ZH: {
        register: "会员注册",
        sever:"享受更多贴心服务",
        names:"账户名称",
        mima:"密码",
        mimas:"请设置登录密码",
        loginInput:"请输入登录账号",
        emails:"请输入邮箱地址",
        email:"邮件地址",
        confirm:"确认密码",
        confirms:"请再次输入密码",
        customer:"客户名称",
        customers:"请输入客户名称",
        phone:"手机号码",
        phones:"请输入手机号码",
        goLogin:"立即注册",
        Zhanghao:"已有账号，立刻登录",
        Kzhanghu:"账户不能为空",
        Kemail:"请输入正确的邮箱地址",

    },
    EN: {
        register: "Member registration",
        sever:"Enjoy more considerate services",
        names:"username",
        mimas:"Please set the login password",
        confirm:"Confirm",
        confirms:"Please enter the password again",

        mima:"password",
        loginInput:"Please enter  account",
        emails:"Please enter the  email",
        email:"Email",
        customer:"customer",
        customers:"Please enter customer name",
        phone:"phone",
        phones:"Please enter  mobile phone number",
        goLogin:"Registerw",
        Zhanghao:"log in now",
        Kzhanghu:"Account cannot be empty",
        Kemail:"请输入正确的邮箱地址",






       
    }
}
export default info